<template src="./MaincategoryAtg.html"></template>

<script>
import axios from 'axios'

const c3 = require('c3')

import Back from '@/components/Dashboard/Back'
import Searchfield from '@/components/Dashboard/Searchfield'
import Settings from '@/components/Dashboard/Settings'
import Years from '@/components/Dashboard/Years'

export default {
  name: 'maincategoryAtg',
  components: { Back, Searchfield, Settings, Years },
  data () {
    return {
      years: this.$parent.years,
      year: '',
      brands: [],
      tmpBrands: [],
      showmore: false,
      sort: 'revenues',
      searchword: '',
      mode: '1',
      sum: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    }
  },
  watch: {
    mode: function() {
      this.$nextTick(function() {
        this.fetchData()
      })
    }
  },
  computed: {
    link: function() {
      return '/dashboard/statistics/maincategories/' + this.$route.params.year + '/' + this.$route.params.hatg
    }
  },
  mounted: function() {
    this.year = this.$route.params.year

    this.fetchData()
  },
  methods: {
    dateRedirect: function() {
      this.$router.push('/dashboard/statistics/maincategories/' + this.year + '/' + this.$route.params.hatg + '/' + this.$route.params.atg)
      this.fetchData()
    },
    reduceList: function(searchword) {
      if(this.tmpBrands.length==0) {
        this.tmpBrands = this.brands
      }

      if(searchword!="") {

        this.brands = this.brands.filter(function(cat) {        
          return cat.name.toLowerCase().indexOf( searchword.toLowerCase())>=0
        })

      } else {

        this.brands = this.tmpBrands

      }
    },
    fetchData: function() {
      this.$parent.loader = 1

      var url = this.$serviceurl + 'statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde') + '/hatg/' + this.$route.params.hatg + '/atg/' + this.$route.params.atg;

      let headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token' : localStorage.getItem('ext-token') };
      let options = { headers: headers };
      
      axios.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year + '&periode=' + this.period, options).then(response => {
        this.$parent.loader = 0
        this.brands = response.data
        if(this.modus=='top') {
          this.brands = this._.orderBy(this.brands, ['umsatzLj'], ['desc']);
        }
        if(this.modus=='flop') {
          this.brands = this._.orderBy(this.brands, ['umsatzLj'], ['asc']);
        }
        this.drawChart()

        if(this.searchword!="") this.reduceList(this.searchword)
      })
      .catch(e => {
        //console.log(e)
      })
    },
    drawChart: function() {
      var tmpCat = this.subcategories

      if(this.mode!='1') {
        this.subcategories = this._.orderBy(this.subcategories,['erloesLj'],['desc'])
      } else {
        this.subcategories = tmpCat
      }
      
      var dataLj = [
        [],
        [],
        [],
        [],
        [],
        []
      ];

      var columnsArr = [];

      var showChart = false

      for (var index = 0; index < this.subcategories.length; index++) {
        if(index<5) {
          if(this.mode=='1') {
            columnsArr.push([this.subcategories[index].name, this.subcategories[index].umsatzLj]);
          }else{
            columnsArr.push([this.subcategories[index].name, this.subcategories[index].umsatzLj]);
          }    
          if(this.subcategories[index].umsatzLj > 0) {
            showChart = true
          }
          dataLj[0].push(this.subcategories[index].id);
          dataLj[1].push(this.subcategories[index].name);
          dataLj[2].push(this.subcategories[index].umsatzLj);
          dataLj[3].push(this.subcategories[index].umsatzVj);
          dataLj[4].push(this.subcategories[index].erloesLj);
          dataLj[5].push(this.subcategories[index].erloesVj);
        }
      }

      let sumArray = this._.slice(this.brands, 5)
      let sum = this._.sumBy(sumArray,'umsatzLj')
      this.sum = sum

      var greys = ['#878787','#9d9d9c','#b2b2b2','#dadada','#ededed'];
      var colors = ['#003366','#1d71b8','#00a19a','#66aa66','#006633'];
      var mixed = [];

      this.$parent.loader = 0

      if(showChart) {
        var pie_chart = c3.generate({
          bindto: "#brandCustomerChart" + this.mode,
          size: { width: 300, height: 300 },
          color: {
            pattern: colors
          },
          data: {
            columns: columnsArr,
            type : 'pie'
          }
        });
      } else {
        $("#brandCustomerChart" + this.mode).html('')
      }
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName(type,value) {
      this.$parent.setName(type,value)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// MaincategoryAtg.vue?5c8dcc66